// Video Play/Pause control
function vidPlayPause() {
    $("video").parent().off();
    
    $("video").parent().click(function(){
          if($(this).find(".video-playpause span").hasClass("vid-pause")) {          
             $(this).find("video")[0].pause();
             $(this).find(".video-playpause span").removeClass("vid-pause");
          } else {
             $(this).find("video")[0].play();
             $(this).find(".video-playpause span").addClass("vid-pause");
          }
    });

}

vidPlayPause();

// Video Play/Pause control END
// window.addEventListener("DOMContentLoaded", function() {   
//  vidPlayPause(); 
// }); 